// Generated by Melange


function getSongElementId(songId) {
  return "song-" + songId;
}

export {
  getSongElementId,
}
/* No side effect */
